const embedHost = 'https://schools.tinybop.com';

// This is a token with student access privelges
/* EXPIRES SEPT 15 2025 */
const embedToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6W1sxLFsiU1RVREVOVCJdXV0sImV4cCI6MTc1Nzk4MDgwMCwic3hwIjowLCJ1c2VyX2lkIjoxM30.tbM1NDq3De-ZWY4lCI7Wnvi4p_qRIvixD4Au_Igtw7Y';

const defaultOptions = {
  embedURI: `${embedHost}/model-embed.html?token=${embedToken}&target=funbrain`,
  height: 580,
  keyboardControl: false,
  mouseControl: true,
  showTitleCard: true,
  tagline: null,
  tags: [],
  tech: 'HTML5',
  type: 'game',
  unlisted: true,
  externalContent: true,
  width: 960,
  isStarted: false,
  gradeRange: {
    higher: 8,
    lower: -1,
  },
  gameControlsText: '<p>Click to select.</p>',
};

export const TINYBOP_EMBEDDED_GAMES = {
  'coral-reef': {
    ...defaultOptions,
    briefDescription: 'Explore underwater with sea creatures.',
    description: '',
    gameObjective:
      '<p>Play and learn about sharks, octopuses, sea turtles, jellyfish, and more. Discover how sea creatures live together in an ecosystem.</p>',
    slug: 'coral-reef',
    title: 'Coral Reef',
  },
  mammals: {
    ...defaultOptions,
    briefDescription: 'Discover how these amazing animals live.',
    description: '',
    gameObjective:
      '<p>Play with and peek inside a tiger, a bat, a kangaroo, an elephant, and a sloth. Explore each animal’s anatomy — bones, fur, whiskers, and more. Every animal is interactive!</p>',
    slug: 'mammals',
    title: 'Mammals',
  },
  space: {
    ...defaultOptions,
    briefDescription: 'Explore our solar system',
    description: '',
    gameObjective:
      '<p>Visit tiny Mercury, fierce Venus, friendly Earth, dusty Mars, stormy Jupiter, elegant Saturn, hazy Uranus & mysterious Neptune.</p>',
    slug: 'space',
  },
  'human-body': {
    ...defaultOptions,
    briefDescription: 'See what we’re made of and how we work.',
    description: '',
    gameObjective:
      '<p>Dive into the skeletal, muscular, nervous, circulatory, respiratory, and digestive systems. The heart beats, guts gurgle, lungs breathe, and eyes see.</p>',
    slug: 'human-body',
    title: 'The Human Body',
  },
  'simple-machines': {
    ...defaultOptions,
    briefDescription: 'Explore the playful side of physics',
    gameControlsText:
      '<p>Click and drag to control each machine. Use the arrow keys to move left and right.</p>',
    gameObjective: '<p>Explore six simple machines to see how they work.</p>',
    description: '',
    slug: 'simple-machines',
    title: 'Simple Machines',
  },
  earth: {
    ...defaultOptions,
    briefDescription: 'Dig into our planet and the forces that shape it',
    gameControlsText:
      '<p>Click and drag to interact with each scene. Use the arrow keys to move left and right.</p>',
    gameObjective:
      '<p>Explore from crust to core to see how our home changes right under our feet.</p>',
    description: '',
    slug: 'earth',
    title: 'The Earth',
  },
  homes: {
    ...defaultOptions,
    briefDescription: 'Explore unique homes around the world',
    gameControlsText:
      '<p>Click and drag to interact with each home. Use the arrow keys to move left and right.</p>',
    gameObjective:
      '<p>See how people live in different countries, geographies, climates, and cultures.</p>',
    description: '',
    slug: 'homes',
    title: 'Homes',
  },
  skyscrapers: {
    ...defaultOptions,
    briefDescription: 'Explore the tallest buildings in the world',
    gameControlsText: '<p>Click and drag to interact with each scene.</p>',
    gameObjective:
      '<p>Investigate skyscrapers from the ground, up, up & up. Learn how people live, work & play inside.</p>',
    description: '',
    slug: 'skyscrapers',
    title: 'Skyscrapers',
  },
    weather: {
    ...defaultOptions,
    briefDescription: 'Experiment with the science of the skies.',
    gameControlsText: '<p>Click and drag to interact with each scene.</p>',
    gameObjective:
      '<p>Play and experiment with the atmospheric forces that make the weather: sun, air, and water.</p>',
    description: '',
    slug: 'weather',
    title: 'Weather',
  }
};
